import { Stack } from "@similarweb/ui-components/foundations";

import { useFormStep } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/hooks/useFormStep";

export const LLMSetupForm = () => {
    const { stepComponent: StepComponent } = useFormStep();

    return (
        <Stack
            gap="24px"
            justifyContent="flex-start"
            width="100%"
            height="fit-content"
            padding="8px 24px 16px 24px"
        >
            <StepComponent />
        </Stack>
    );
};
